var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footerContainer"},[(_vm.prepaidcardData.temImg)?_c('img',{attrs:{"src":_vm.lang == 'zh' ? _vm.prepaidcardData.temImg.cnImg : _vm.prepaidcardData.temImg.enImg}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }